<div
  role="button"
  (click)="onMaximize()"
  class="flex w-72 cursor-pointer flex-col gap-1 rounded-2xl border-0 bg-brand p-4 text-left text-white outline-none hover:bg-primary-600"
>
  <div class="flex w-full items-center justify-between gap-2 text-base font-semibold">
    <p class="m-0">
      {{ title }}
    </p>
    <div class="flex items-center gap-2">
      <sb-icon class="m-2 w-2" [name]="'chevron-up'" />
      <button (click)="onClose($event)" sb-icon-button [color]="'transparent'">
        <sb-icon class="text-white" [name]="'times'" />
      </button>
    </div>
  </div>

  @if (progress) {
    <div class="flex w-full items-center gap-2">
      <sb-progress-bar class="w-full" [level]="progress.level" [theme]="progress.theme || 'white'"></sb-progress-bar>
      <small class="w-8">{{ progress.level }}%</small>
    </div>
  }
</div>
